import { sql } from 'drizzle-orm'
import {
  integer,
  pgEnum,
  pgTable,
  text,
  uniqueIndex,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getMonetaryField,
  getTimestampWithTimezone,
} from '../common/utils'

export const discountCodeTypeEnum = pgEnum('discount_code_type', [
  'percent',
  'fixed',
])

export const discountCodes = pgTable(
  'discount_codes',
  {
    ...getBaseFields(),
    // Stored uppercase; lookups normalize the customer input to uppercase too.
    // Uniqueness is a partial index (below) scoped to live rows, so a code
    // string can be reused after the old code is soft-deleted.
    code: text().notNull(),
    description: text(),
    // 'percent' → `value` is a percentage (e.g. 10 = -10%).
    // 'fixed'   → `value` is a gross (VAT-inclusive) euro amount (e.g. 10 = -10 €).
    discountType: discountCodeTypeEnum().notNull(),
    value: getMonetaryField().notNull(),
    // Validity window. Both nullable: null validFrom = valid immediately,
    // null validUntil = no expiry. Compared as absolute instants (tz-agnostic).
    validFrom: getTimestampWithTimezone(),
    validUntil: getTimestampWithTimezone(),
    // Optional restriction to one booking-widget service (ServicePresetKey).
    // Null = any service. Only enforced where the preset is known (public
    // booking); an officer applying the code in the ERP is trusted.
    servicePreset: text(),
    // Null = unlimited. Personal vouchers use 1; redemptions are counted from
    // live visit_line_items rows referencing the code.
    maxRedemptions: integer(),
  },
  (table) => [
    ...getBaseIndexes('discount_codes', table),
    // Unique per live code only — soft-deleted rows keep their code string but
    // don't block recreating it.
    uniqueIndex('discount_codes_code_unique_idx')
      .on(table.code)
      .where(sql`${table.deletedAt} IS NULL`),
  ],
)
